export const coefColorClass = (coefIncreased: boolean): string => {
    if (coefIncreased === null) {
        return '';
    }

    return ` ${coefIncreased ? 'increase-coefficient' : 'decrease-coefficient'}`;
};
